var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.73 15.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.58,3.65c2.7,0,4.9-.8,4.9-1.7S11.28.25,8.58.25,3.68,1,3.68,2v.1C3.78,3,5.88,3.65,8.58,3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.08,3.35c.3-.3.5-.6.4-.7h-.1a.66.66,0,0,0-.7.2c-.3.3-.5.6-.4.7h0C.38,3.75.78,3.65,1.08,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.48,12.15a1.1,1.1,0,0,0-.6-1,.9.9,0,0,0-.5-.1,1.27,1.27,0,0,1-.6-.1c-.2,0-.3-.2-.4-.4V8.85h0V2c0,1-2.2,1.7-4.9,1.7S3.78,3,3.68,2h0v2.8l-2.1-2h0c0,.2-.2.4-.5.6a1.08,1.08,0,0,1-.7.3h0l3.3,3.9v.1h0v2.8c0,.4-.1.5-.5.6a2.2,2.2,0,0,0-.8.1,1.06,1.06,0,0,0-.8.9V14c0,.2.2.3.3.4a.55.55,0,0,0,.5-.3c.2-.4.3-.7.5-1.1a.46.46,0,0,1,.5-.3h1.1a.79.79,0,0,0,.8-.5.76.76,0,0,0,.2-.5v-.2a1.06,1.06,0,0,1,.6-.7.83.83,0,0,1,.8.3c.1.2.2.3.2.5a1.14,1.14,0,0,0,.3.8c.1.2.3.2.6.3L9,13a1,1,0,0,1,.5.4,3.51,3.51,0,0,1,.5.8,5.58,5.58,0,0,1,.5.8.73.73,0,0,0,.6.2c.2-.1.2-.2.2-.5s-.1-.8-.2-1.2c-.1-.7-.1-.7-.7-1.1l-.1-.1c-.3-.3-.4-.3-.3-.8a.79.79,0,0,1,.8-.8c.4,0,.7.3.8.8a.76.76,0,0,0,.2.5,1.05,1.05,0,0,0,.9.5h1c.4,0,.4,0,.6.4a3.58,3.58,0,0,1,.4,1.1.55.55,0,0,0,.5.3c.2,0,.3-.2.3-.4Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon3);
export default __webpack_public_path__ + "static/media/nav-icon3.64dca3ed59686f9b18aecc7424ecb320.svg";
export { ForwardRef as ReactComponent };